import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import api from "../services/api";

const Context = createContext({});
export function LearningProgressProvider({ children, revision }) {
  const [progress, setProgress] = useState({});
  const request = useRef(0);
  useEffect(() => {
    const current = ++request.current;
    let active = true;
    api.get("learning-progress/", { timeout: 15000 }).then(({ data }) => {
      if (active && current === request.current) setProgress(data || {});
    }).catch(() => {}); // A failed read must never erase known achievements.
    return () => { active = false; };
  }, [revision]);
  return <Context.Provider value={progress}>{children}</Context.Provider>;
}
export function useActivity(kind, id) {
  return useContext(Context)?.[kind]?.[id] || null;
}

export function ActivityStatus({ kind, id, action = false, fallback }) {
  const item = useContext(Context)?.[kind]?.[id];
  const media = kind === "video" || kind === "audio";
  const termine = media && item && (item.percent ?? 100) >= 100;
  if (action) {
    if (!item) return fallback;
    if (media) return termine ? (kind === "video" ? "Revoir" : "Réécouter") : "Continuer";
    return { lecon: "Relire", qcm: "Refaire", exercice: "Refaire" }[kind];
  }
  if (!item) return null;
  if (media && !termine) {
    return <div className="ql-activity-status">
      <span><i className="bi bi-hourglass-split me-1" aria-hidden="true" />{kind === "video" ? "Vue" : "Écouté"} à {item.percent} %</span>
    </div>;
  }
  return <div className="ql-activity-status">
    <span><i className="bi bi-check-circle-fill me-1" aria-hidden="true" />{kind === "lecon" ? "Déjà consultée" : kind === "video" ? "Déjà vue (100 %)" : kind === "audio" ? "Écouté (100 %)" : "Déjà réalisé"}</span>
    {item.last_score != null && <span>Dernière note : {item.last_score} %</span>}
    {item.best_score != null && <span>Meilleure note : {item.best_score} %</span>}
  </div>;
}
